document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('[data-back-button]');
  if (!btn) return;

  const url = new URL(window.location.href);
  const handle = url.searchParams.get('collection');
  const defaultText = btn.dataset.defaultText;

  if (handle && defaultText) {
    btn.textContent = `${defaultText} ${handle.replace('-', ' ').toUpperCase()}`;
  }

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    if (document.referrer &&
        document.referrer.startsWith(window.location.origin)) {
      history.back();
    } else if (btn.dataset.fallbackUrl) {
      window.location.href = btn.dataset.fallbackUrl;
    }
  });
});